<div>
    <h4>{{ title() }}</h4>

    @if (description()) {
    <p>{{ description() }}</p>
    }
    @if(label()) {
    <p class="{{subtitleColor()}}"> {{ label() }} </p>
    }
</div>
